import React, { useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { StyleRoot } from 'radium';

import './Insurance.scss';
import PersonalizationContainer from '../../containers/PersonalizationContainer';
import NavigationBar from '../NavigationBar';
import Currency from '../Currency';
import bem from '../../utils/bem';
import Skeleton from '../Skeleton';
import { ANIMATIONS } from '../../utils/constants';
import Close from './SVG/Close';
import Icon from './SVG/Icon';
import Check from '../Version/SVG/Check';
import { useQuery } from '../../utils/hooks';
import ExtrasActualizar from '../Extras/ExtrasActualizar';
import Empty from '../Extras/Empty';
import useIsTablet from '../useIsTablet/useIsTablet';

const InsuranceOption = ({ insuranceOption, changeInsurance, setOpenedInsurance, openedInsurance }) => {
  const selected = insuranceOption?.id === openedInsurance?.id; 
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  return (
    <div
      className={bem('insurance-option', {
        selected: selected || insuranceOption?.selected,
      })}
    >
      <button
        className="insurance-option__button-main"
        onClick={() => {
          setOpenedInsurance(selected ? {} : insuranceOption);
          if (!selected && insuranceOption?.selected) {
            return;
          }
          changeInsurance(insuranceOption);
        }}
      >
        <span className="insurance-option__button">
          <span className="insurance-option__icon">
            <Icon />
          </span>
          <div className="insurance-option__image">
            <img src={insuranceOption?.imagenUrl} alt={insuranceOption?.nombre || ''} />
          </div>
          <div className="insurance-option__info">
            <div className="insurance-option__name">
              <div className="insurance-option__name-text">
                {insuranceOption?.nombre}
              </div>
            </div>
            <div className="insurance-option__price">
              <Currency value={insuranceOption.precio} />
              {/* <span className="sign-icon">
                {insuranceOption?.selected ? (
                  <img src={check} alt="Check" />
                ):(
                  <Plus />
                )}
                
              </span> */}
            </div>
          </div>
        </span>
       
      </button>
      {/* {expanded && (
        <StyleRoot> */}
      <StyleRoot>
      {selected && (
        <div style={{ ...ANIMATIONS.fadeIn, paddingBottom: height }}>
          <div className="special-arrow insurance-option__arrow">
            <span />
          </div>
          <div className="insurance-option__more-info"
          ref={r => {
            ref.current = r;
            setHeight(r?.clientHeight || 0);
          }}>
            <button className="insurance-option__close" onClick={() => {
              setOpenedInsurance({});
            }}>
              <Close />
            </button>
            <ul>
              {insuranceOption.characteristics.map(characteristic => (
                <li
                  key={characteristic.id}
                  className="insurance-option__characteristic"
                >
                  <Check />
                  {/* <img src={check} alt="Check" /> */}
                  <div className="insurance-option__characteristic-text">
                    {characteristic.text}
                  </div>
                </li>
              ))}
            </ul>
            <div className="insurance-option__bottom">
              <p className="insurance-option__bottom-text">
                * Montos aproximados, sujetos a variación.
              </p>
            </div>
          </div>
        </div>
      )}
      </StyleRoot>
      {/* <AnimateHeight height={insuranceOption?.id === openedInsurance?.id ? 'auto' : 0}>
        
      </AnimateHeight> */}
      {/* </StyleRoot>
      )} */}
    </div>
  );
};

const InsuranceList = ({ insuranceList, changeInsurance, setOpenedInsurance, openedInsurance }) => (
  <div className={bem('insurance-list', {
    'centered': insuranceList?.length !== 3
  })}>
    {insuranceList?.map(insurance => (
      <InsuranceOption
        key={insurance.id}
        insuranceOption={insurance}
        changeInsurance={changeInsurance}
        setOpenedInsurance={setOpenedInsurance}
        openedInsurance={openedInsurance}
      />
    ))}
  </div>
);

const Loader = () => (
  <div className="insurance__skeleton">
    <div className="insurance__skeleton-row skeleton">
      <Skeleton>
        <div className="insurance__skeleton-bone skeleton__box" />
      </Skeleton>
    </div>
    <div className="insurance__skeleton-row">
      <Skeleton>
        <div className="insurance__skeleton-bone skeleton__box" />
      </Skeleton>
    </div>
  </div>
);

const Insurance = ({
  insuranceList,
  financeOptions,
  isLoading,
  changeInsurance,
  price,
  prime,
  changePrimePercentage,
  selectFinancingOption,
  colorCode,
  personalization,
  banners,
}) => {
  const { tipo, modelo, color, version, anio } = useParams();
  const [openedInsurance, setOpenedInsurance] = useState(null);
  const isEmpty = !personalization.isLoading && personalization.isReady && (insuranceList || []).length === 0;

  const isTablet = useIsTablet();

  const query = useQuery();
  const type = query.get('back');
  return (
    <PersonalizationContainer
        title="SEGUROS"
        subTitle="Manejá con tranquilidad. Agregá un seguro para vehículos."
    >
    <div className={bem('insurance', {
      'is-summary': !!type
    })} style={{ '--color': colorCode }}>
        <NavigationBar
          back={`/${tipo}/${modelo}/${version}/${anio}/${color}/mantenimientos/`}
          next={`/${tipo}/${modelo}/${version}/${anio}/${color}/financiamiento/`}
        />
      
      {isLoading ? (
        <Loader />
      ) : (
        <StyleRoot>
          <div className="title-wrapper" style={{marginTop: '2.11rem'}}>
            <h6 className="title-button">SEGUROS PARA VOS</h6>
          </div>
          {!isEmpty && <span className="insurance__instructions">Seleccioná el seguro que vaya más con vos.</span>}
          {/* <div className="insurance__content" style={ANIMATIONS.fadeIn}>
             
          </div> */}
           {!isEmpty && <InsuranceList
              insuranceList={insuranceList}
              changeInsurance={changeInsurance}
              openedInsurance={openedInsurance}
              setOpenedInsurance={setOpenedInsurance}
            />}
            {isEmpty && <Empty bottomMargin message="En este momento no tenemos seguros para este vehículo" />}
            <ExtrasActualizar type={type} tipo={tipo} modelo={modelo} version={version} anio={anio} color={color} />
        </StyleRoot>
      )}
      {banners?.length > 0 && (
        <div className="insurance__futura">
          <div className="insurance__futura--inner">
            <a href="https://asegurate.ins-cr.com//frmLogin.aspx" target="_blank" rel="noopener noreferrer">
              {isTablet ? (
                <img className="insurance__futura--inner__img" src={banners[0]?.imagen_mobile} alt="Futura banner" />
              ): (
                <>
                <img className="insurance__futura--inner__img" src={banners[0]?.imagen} alt="Futura banner" />
                </>
              )}
              
            </a>
          </div>
        </div>
      )}
      <NavigationBar
        back={`/${tipo}/${modelo}/${version}/${anio}/${color}/mantenimientos/`}
        next={`/${tipo}/${modelo}/${version}/${anio}/${color}/financiamiento/`}
      />
    </div>
    </PersonalizationContainer>
  );
};

export default Insurance;
